function getIOSVersion() {
  // https://stackoverflow.com/a/76055505
  const tokens = /iP(hone|ad|od) OS ([1-9]*)/i.exec(window.navigator.userAgent);
  if (!tokens) {
    return NaN;
  }
  return tokens[2] || NaN;
}

export function getRuntimeEnv() {
  let runtime = {
    // OS
    android: navigator.userAgent.indexOf('Android') > -1,
    iphone: navigator.userAgent.indexOf('iPhone') > -1,
    iOS: false,
    linux: navigator.userAgent.indexOf('Linux') > -1,
    mac: navigator.userAgent.indexOf('Macintosh') > -1,
    unix: navigator.userAgent.indexOf('UNIX') > -1,
    windows: navigator.userAgent.indexOf('Win') > -1,
    // Browsers
    chrome: navigator.userAgent.indexOf('Chrome') > -1,
    edge: window.navigator.userAgent.indexOf('Edge') > -1,
    firefox: navigator.userAgent.indexOf('Firefox') > -1,
    safari: navigator.userAgent.indexOf('Safari') > -1,
  };

  // Let's make linux and unix mean the same thing.
  if (runtime.unix || runtime.linux) {
    runtime.linux = true;
    runtime.unix = true;
  }

  if (runtime.chrome) {
    if (runtime.edge) {
      // Edge user-agent may also include others we don't need.
      runtime.chrome = false;
      runtime.safari = false;
    } else if (runtime.iphone || runtime.mac) {
      // Chrome on iOS is basically a reskinned Safari, treat it as such.
      runtime.chrome = false;
      runtime.safari = true;
    } else if (runtime.safari) {
      // Chrome also includes 'Safari' in its User Agent...
      runtime.chrome = true;
      runtime.safari = false;
    }
  }

  if (runtime.iphone) {
    // Safari on iOS has some specific quirks we need to handle, so add
    // an extra indicator that iOS is being used. We don't check for
    // Safari here since a UIWebView on iOS would not match that.
    runtime.iOS = true;
  }

  if (runtime.chrome && runtime.opera) {
    runtime.chrome = false;
  }

  return runtime;
}

export const runTimeEnv = getRuntimeEnv();

var runtime = {
  methods: {
    /**
     * Detect which OS + browser we are in.
     */
    detectRuntimeEnvironment() {
      this.$store.commit('SET_RUNTIME_ENV', runTimeEnv);
    },
  },
};

export default runtime;



// WEBPACK FOOTER //
// ./src/mixins/runtime.js